import MenuItem from '@Web/Pages/Web/Layout/Components/Header/Components/MenuItem';
import Button from '@Web/Src/Components/Button';
import { router } from '@inertiajs/react';

const Menu = ({ menuOpened, menu, setSubMenuOpened }) => {
    if (!menuOpened) return null;

    const handleDemo = () => {
        router.visit(route('web.pages.demo'));
    };

    return (
        <div className={'flex flex-wrap justify-center gap-4'}>
            <div className={'flex flex-col justify-between'}>
                {menu.content.map((group, groupIndex) => (
                    <div className={'min-w-[650px]'} key={groupIndex}>
                        <p className={'text-tertiary ml-4 text-xl'}>{group.menuTitle}</p>
                        <div className={'mt-2 flex max-w-[650px] flex-wrap'}>
                            {group.items.map((item, itemIndex) => (
                                <MenuItem
                                    key={itemIndex}
                                    item={item}
                                    setSubMenuOpened={setSubMenuOpened}
                                />
                            ))}
                        </div>
                    </div>
                ))}
            </div>

            <div className='round x_large:max-w-[400px] medium:max-w-[300px] relative flex w-full !max-w-[400px] flex-col items-center justify-center overflow-hidden rounded-3xl'>
                <img
                    className='hidden h-max w-[400px] max-[1080px]:block'
                    src={menu.imgPath}
                    alt='Customer Referral Program'
                />
                {menu.content?.[0]?.menuTitle !== 'INTEGRATIONS' && (
                    <div
                        className={
                            'absolute bottom-0 right-0 max-w-[300px] p-6 pb-16 text-center'
                        }
                    >
                        <p className={'text-dark text-[32px] font-semibold leading-10'}>
                            {__('See Referral Factory in action')}
                        </p>
                        <Button
                            onClick={handleDemo}
                            className={'!bold mx-auto mt-5 !min-w-32 !text-lg'}
                            name={__('Schedule Demo')}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

export default Menu;
